module.exports = __webpack_public_path__ + "media/images/tmp/slide10-9614b49a4f4e2c99002a74c177427fc6.jpg";